import Model from '@/lib/data/Model';

class VisitNathanGraph extends Model {
    fields = [{ name: 'nathan_graph_json', type: 'json' }];

    constructor(data) {
        super(data);
        this.init();
    }

    api = [
        {
            name: 'read',
            url: '/nathan/result',
            params: ['visit_id', 'language_code'],
        },
    ];
}

export default VisitNathanGraph;
